
import GlassProductionStationAPIService from '@/apps/glass-production-station/src/services/apiService'

export default class GlassProductionStationModule {
  constructor() {
  }

  install(Vue) {
     // Services
     Vue.prototype.$apiService.glassProductionStationService = new GlassProductionStationAPIService(Vue.prototype.$api, Vue.prototype.$reportingApi)
  }


  getRoutes() {
    return [
      {
        path: '/apps/glass-production-station/:id/stage/:stageId',
        name: 'GlassProductionStation',
        component: () => import('@/apps/glass-production-station/src/views/app.vue'),
        meta: {
          requiresAuth: true,
          layout: 'blank',
          title: 'Glass Production Station',
          menuLink: '/apps/glass-production-station',
          breadcrumbs: [
              { title: 'Home', link: '/'},
          ],
        }
      }
    ]
  }
}